import { useEffect, useState } from 'react';

/**
 * Debounce wartości z opóźnieniem.
 *
 * Wzorzec skopiowany z WiseTraderOfferSemanticSearch.tsx:37 - jedyna lokalna implementacja debounce
 * używana w projekcie. Świadomie nie używamy lodash/debounce aby uniknąć bundle bloat.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const handle = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(handle);
  }, [value, delayMs]);

  return debounced;
}
